import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { InputProps } from './types';

export default function CityInput({ options, value, onChange }: InputProps) {
  if (options.city?.show === false) {
    return null;
  }

  return (
    <ManagedFormGroup
      hasError={options.city?.hasError}
      label="City"
      required={options.city?.required !== false}
      value={value.city}
      onValueChange={city => onChange({ ...value, city })}
    />
  );
}
